import { useUsers } from './useUsers';
import { useMemo } from 'react';

export const useAssignees = (formOwnerId: number) => {
  const { data, isLoading } = useUsers();

  const filteredUsers = useMemo(
    () =>
      (data ?? []).filter(
        (u) =>
          u.permissions.includes('feature_enabled_quality_events') &&
          u.permissions.includes('can_work_on_issue') &&
          u.id !== formOwnerId,
      ),
    [data, formOwnerId],
  );

  return {
    data: filteredUsers,
    isLoading: isLoading,
  };
};
